import { MobilePopupBottom, RadioButton } from '@lt/components';
import React from 'react';
import { pluralizeOrder } from 'src/utils/pluralizeUtils';
import styled from 'styled-components';
import { orderNumberArray } from '../../../../constants';
import type { OrderAmountFormMobileProps } from '../../../../types';

const OrdersAmountMobile = (props: OrderAmountFormMobileProps) => {
  const {
    setIsOrdersAmountFieldOpened,
    isOrdersAmountFieldOpened,
    fieldValue,
    setFieldValue,
    labelText,
  } = props;
  const handleRadioButtonClicked = (orderNumber: number) => {
    setFieldValue(orderNumber);
    setIsOrdersAmountFieldOpened(false);
  };
  return (
    <StyledMobilePopupBottom
      onClick={() => setIsOrdersAmountFieldOpened(false)}
      visible={isOrdersAmountFieldOpened}
      options={{ showHandlebar: true }}
    >
      <StyledContentContainer>
        <StyledTitle>{labelText}</StyledTitle>
        <StyledRadioButtonContainer>
          {orderNumberArray.map((orderNumber) => (
            <StyledRadioButtonItem key={orderNumber}>
              {orderNumber} {pluralizeOrder(orderNumber)}
              <RadioButton
                value={orderNumber}
                name="orderAmount"
                checked={fieldValue === orderNumber}
                onClick={() => handleRadioButtonClicked(orderNumber)}
              />
            </StyledRadioButtonItem>
          ))}
        </StyledRadioButtonContainer>
      </StyledContentContainer>
    </StyledMobilePopupBottom>
  );
};
const StyledMobilePopupBottom = styled(MobilePopupBottom)`
  padding: 12px 0 16px 0;
`;
const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const StyledTitle = styled.div`
  padding: 0 16px;
  color: #17181a;
  font-size: 22px;
  font-weight: 700;
`;
const StyledRadioButtonContainer = styled.div`
  padding: 0 8px;
`;
const StyledRadioButtonItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px;
  font-size: 18px;
  height: 40px;
  font-weight: 400;
`;

export default OrdersAmountMobile;
